
import Vue from 'vue'
import Vuex from 'vuex'
import Axios from "axios"
Vue.use(Vuex)

export default new Vuex.Store({
  //变量名 不要和 组件里面相同
  state: {

    // 所有店铺类型
    AllShopTypes: {},
    // 美食店铺类型
    DeliciousFoodShopTypes: [],
    // 购物店铺类型
    ShoppingStoreTypes: [],
    // 美食店铺数据
    DeliciousFoodShopDatas: [],
    // 购物店铺数据
    ShoppingStoreDatas: [],
    // 某个店铺数据
    thatStoreData: {},
    // 楼层编号
    FloorNumbering: [],
    // 地图所有数据
    MapAllData: [],
    // 某个车数据
    thatCarData: [],
    //数据页面存放的商铺数据列表
    DataPageList:[],
    //App页获取的地图数据
    AppMapAllData:[]
  },
  mutations: {

    // 所有店铺类型
    fun_AllShopTypes(state, item) { 
      state.AllShopTypes = item
    },
    // 美食店铺类型
    fun_DeliciousFoodShopTypes(state, item) {
      state.DeliciousFoodShopTypes = item
    },
    // 购物店铺类型
    fun_ShoppingStoreTypes(state, item) {
      state.ShoppingStoreTypes = item
    },
    // 美食店铺数据
    fun_DeliciousFoodShopDatas(state, item) {
      state.DeliciousFoodShopDatas = item
    },
    // 购物店铺数据
    fun_ShoppingStoreDatas(state, item) {
      state.ShoppingStoreDatas = item
    },
    // // 某个店铺数据

    fun_thatStoreData(state, item) {
      state.thatStoreData = item
    },
    // // 楼层编号
    fun_FloorNumbering(state, item) {
      state.FloorNumbering = item
    },
    // // 地图所有数据
    // fun_MapAllData(state, item) {
    //   state.MapAllData = item
    // },
    fun_DataPageList(state, item) { 
      state.DataPageList = item
    },
    //App页获取的地图数据 地图所有数据
    fun_AppMapAllData(state, item) {
      state.AppMapAllData = item
    },
    // // 某个车数据
    // fun_thatCarData(state, item) {
    //   state.thatCarData = item
    // },
  },
})
